import React from 'react';
import { Button } from 'antd';
import { ColumnsType } from 'antd/es/table';
import moment from 'moment';

import { ManagedStartupType } from 'packages/venture_builder_repository';
import { ManagedStartupsTableProps } from 'types/ventureBuilders';
import { formatSlashMDY } from 'components/utils/constants/formatters';
import { RowTable } from 'components/components';
import NOT_SPECIFIED from 'utils/constants/display';
import { parseNumberToPrice } from 'utils/helpers/priceFormatters';

const walletValue = (startup: ManagedStartupType, key: 'total' | 'balance' | 'blocked' | 'consumed') => (
  startup.wallet ? parseNumberToPrice(startup.wallet[key], 'AED') : NOT_SPECIFIED
);

const ManagedStartupsTable = ({ startups, isLoading, onEdit }: ManagedStartupsTableProps) => {
  const columns: ColumnsType<ManagedStartupType> = [
    { key: 'name', title: 'Startup', dataIndex: 'name' },
    { key: 'email', title: 'Contact email', dataIndex: 'email' },
    { key: 'total', title: 'Wallet', render: (_, startup) => walletValue(startup, 'total') },
    { key: 'balance', title: 'Balance', render: (_, startup) => walletValue(startup, 'balance') },
    { key: 'blocked', title: 'Blocked', render: (_, startup) => walletValue(startup, 'blocked') },
    { key: 'consumed', title: 'Consumed', render: (_, startup) => walletValue(startup, 'consumed') },
    {
      key: 'createdAt',
      title: 'Created',
      dataIndex: 'createdAt',
      render: (value: string | null) => (value ? moment(value).format(formatSlashMDY) : NOT_SPECIFIED),
    },
    {
      key: 'actions',
      render: (_, startup) => (
        <Button className="secondary-button" aria-label={`Edit ${startup.name}`} onClick={() => onEdit(startup)}>
          Edit
        </Button>
      ),
    },
  ];

  return (
    <RowTable
      className="managed-startups-table"
      rowKey="id"
      isLoading={isLoading}
      columns={columns}
      dataSource={startups}
      scroll={{ x: true }}
    />
  );
};

export default ManagedStartupsTable;
